import type { ReactNode } from "react";
import "./DateNavigator.scss";
import type { DateTime } from "luxon";
import DatePicker from "@/shared/components/generic/date/date-navigator/date-picker/DatePicker";
import PreviousNextButton from "@/shared/components/generic/button/PreviousNextButton";
import type { Direction } from "@/shared/components/generic/button/PreviousNextButton";

interface Properties {
  timeZone: string;
  value: DateTime;
  onChange: (d: DateTime) => void;
}

export default function DateNavigator(props: Properties): ReactNode {
  return (
    <div className="date-navigator">
      {renderButton("previous")}
      <DatePicker
        timeZone={props.timeZone}
        value={props.value}
        onChange={props.onChange}
      />
      {renderButton("next")}
    </div>
  );

  function renderButton(direction: Direction): ReactNode {
    return (
      <div className="navigate-button">
        <PreviousNextButton
          direction={direction}
          onClick={() => {
            addDays(direction === "previous" ? -1 : 1);
          }}
        />
      </div>
    );
  }

  function addDays(delta: number): void {
    props.onChange(props.value.plus({ day: delta }));
  }
}
